import { getCredentialsLocal, setCredentialsLocal } from 'utils/localData/credentials'
import {
  LOCAL_CREDENTIALS,
  GET_LOCAL_CREDENTIALS,
  SET_USER_DETAILS,
  SET_GLOBAL_SITE,
  SET_GLOBAL_COMPANY,
  RESET,
  GET_LOGIN_CONFIGS
} from 'fixtures/actions'
import { login, getMyDetails, loginConfig, loginAzure, verifyTwoFaCode, resendTwoFaCode } from 'services/authService'

const getLocalUserData = () => {
  return dispatch => {
    getCredentialsLocal((data) => {
      dispatch({
        type: GET_LOCAL_CREDENTIALS,
        payload: data
      })
    })
  }
}

// setting local user login data
const setLocalUserData = (data) => {
  return dispatch => {
    setCredentialsLocal(data)

    dispatch({
      type: LOCAL_CREDENTIALS,
      payload: data
    })
  }
}

// send login credentials to server
const sendLogin = (data) => {
  return async dispatch => {
    let newData = await login(data)

    dispatch({
      type: LOCAL_CREDENTIALS,
      payload: newData
    })
  }
}

// send login azure credentials to server
const sendLoginAzure = (data) => {
  return async dispatch => {
    let newData = await loginAzure(data)

    dispatch({
      type: LOCAL_CREDENTIALS,
      payload: newData
    })
  }
}

// get currently logged in user details data
const getMyDetailsData = () => {
  return async dispatch => {
    let data = {}
    let newData = await getMyDetails()
    if (newData) {
      data = newData
    }

    dispatch({
      type: SET_USER_DETAILS,
      payload: data
    })

    dispatch({
      type: SET_GLOBAL_SITE,
      payload: data.originCompany ? data.originCompany.workLocation : data.allowedCompanies.length ? data.allowedCompanies[0].workLocation : undefined
    })

    const originCompanyDataFromAllowedCompanies = data.allowedCompanies.find(company => company.id === data.originCompany.id)
    dispatch({
      type: SET_GLOBAL_COMPANY,
      payload: data.originCompany && originCompanyDataFromAllowedCompanies ? originCompanyDataFromAllowedCompanies : data.allowedCompanies[0]
    })
  }
}

const reset = () => {
  return dispatch => dispatch({
    type: RESET
  })
}

const getLoginConfigs = () => {
  return async dispatch => {
    let newData = await loginConfig()

    dispatch({
      type: GET_LOGIN_CONFIGS,
      payload: newData
    })
  }
}

const sendVerifyTwoFaCode = (data) => {
  return async dispatch => {
    let newData = await verifyTwoFaCode(data)

    dispatch({
      type: LOCAL_CREDENTIALS,
      payload: newData
    })
  }
}

const sendResendTwoFaCode = (data) => {
  return async dispatch => {
    let newData = await resendTwoFaCode(data)

    dispatch({
      type: LOCAL_CREDENTIALS,
      payload: newData
    })
  }
}

export { getLocalUserData, setLocalUserData, sendLogin, sendLoginAzure, getMyDetailsData, reset, getLoginConfigs, sendVerifyTwoFaCode, sendResendTwoFaCode }
